import React from "react";
import './section10.css';
import imagemSection10 from '../../assets/Metas_Premiadas/Metas_Premiadas2.svg'

const Section10 = () => {
  return (
    <section className="section10">        
      <img src={imagemSection10} alt="Descrição da Imagem" className="section10-image" />

    </section>
  );
};

export default Section10;
